export const EMBEDDED_SIGNUP_VERSIONS = ['v2', 'v3', 'v4'] as const;

export type EmbeddedSignupVersion = (typeof EMBEDDED_SIGNUP_VERSIONS)[number];

export const DEFAULT_EMBEDDED_SIGNUP_VERSION: EmbeddedSignupVersion = 'v4';

export interface EmbeddedSignupLoginOptions {
  config_id: string;
  response_type: 'code';
  override_default_response_type: true;
  extras: {
    sessionInfoVersion: '3';
    version: EmbeddedSignupVersion;
  };
}

export const buildEmbeddedSignupOptions = (
  configId: string,
  version: EmbeddedSignupVersion = DEFAULT_EMBEDDED_SIGNUP_VERSION
): EmbeddedSignupLoginOptions => ({
  config_id: configId,
  response_type: 'code',
  override_default_response_type: true,
  extras: {
    sessionInfoVersion: '3',
    version,
  },
});

export interface UserActivationSnapshot {
  eventIsTrusted: boolean | null;
  isActive: boolean | null;
  hasBeenActive: boolean | null;
  documentHasFocus: boolean;
  visibilityState: DocumentVisibilityState;
  isSecureContext: boolean;
  isTopLevelWindow: boolean;
}

export const getUserActivationSnapshot = (
  event?: Pick<Event, 'isTrusted'>
): UserActivationSnapshot => {
  const activation = (
    navigator as Navigator & {
      userActivation?: { isActive: boolean; hasBeenActive: boolean };
    }
  ).userActivation;

  return {
    eventIsTrusted: event ? event.isTrusted : null,
    isActive: activation?.isActive ?? null,
    hasBeenActive: activation?.hasBeenActive ?? null,
    documentHasFocus: document.hasFocus(),
    visibilityState: document.visibilityState,
    isSecureContext: Boolean(window.isSecureContext),
    isTopLevelWindow: window.top === window,
  };
};
